import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { uuid } from '~/helpers/common';
import Notify from '@/mixins/notify';

export const addSection = ({commit, state}, payload = null) => {
  // check if have selected block
  const path = payload || state.currentSelection;

  if(path) {
    const newSectionIndex = get(state.convertData, `${path}.children`).length;

    commit('addSection', {
      payload: {
        path: `${path}.children[${newSectionIndex}]`,
        type: 'section',
        children: [],
        updateTime: new Date().getTime(),
        options: {
          isLoop: false,
          questionId: null,
          hasCondition: false,
          conditions: null,
          condition_options: [],
          required_all: false
        }
      },
      parent: `${path}.children`
    })
  } else {
    commit('addSection', {
      payload: {
        path: `[${state.convertData.length}]`,
        type: 'section',
        children: [],
        updateTime: new Date().getTime(),
        options: {
          isLoop: false,
          questionId: null,
          hasCondition: false,
          conditions: null,
          condition_options: [],
          required_all: false
        }
      },
      parent: null
    })
  }
}

function fetchPlaceholder(component, { commit, state }) {
  let placeholders
  let ids
  let content
  switch (component.type) {
    case 'section':
      component.children.forEach(item => fetchPlaceholder(item, { commit, state }))
      break;
    case 'proposal':
      placeholders = component.content.filter(item => item.type === 'fieldInstance')
      ids = [...state.removeInstanceFields, ...placeholders].map(item => item.uuid);
      ids.sort();

      commit('setRemovePlaceholders', ids);
      break;
    case 'paragraph':
      content = [
        ...component.content,
        ...component.proposals.reduce((acc, proposal) => {
          acc = [...acc, ...proposal.content]

          return acc;
        }, [])
      ];

      placeholders = content
        .filter(item => item.hasOwnProperty('uuid'))
        .map(item => item.uuid);

      ids = [...state.removeInstanceFields, ...placeholders];
      ids.sort();

      commit('setRemovePlaceholders', ids);
      break;

    case 'newParagraph':
      placeholders = component.json.content.reduce((acc, content) => {
        if (!content.content) {
          return acc;
        }

        const partIds = content.content.reduce((carry, part) => {
          if (part.type === 'mention') {
            carry = [...carry, part.attrs.id];
          }
          return carry;
        }, [])

        acc = [...acc, ...partIds];
        return acc;
      }, [])

      ids = [...state.removeInstanceFields, ...placeholders];
      ids.sort();
      commit('setRemovePlaceholders', ids);
      break;

    case 'newList':
    case 'newListItem':
        component.children.forEach(item => fetchPlaceholder(item, { commit, state }));
      break;
    case 'table':
      component.children.forEach(row => {
        row.items.forEach(cell => {
          if(cell.component && !cell.skip) {
            fetchPlaceholder(cell.component, {commit, state})
          }
        })
      })
      break;
    default:
      break;
  }
}

export const removeComponent = async ({commit, state}, path) => {
  const regex = new RegExp('^[0-9\\[\\]]+$', 'g');
  let payload;

  // check placeholder
  const component = get(state.convertData, path);
  fetchPlaceholder(component, { commit, state });

  if(regex.test(path)) {
    const removeIndex = parseInt(path.replaceAll(/[^\d]/g, ''));

    const convertData = cloneDeep(state.convertData).filter((item, index) => index !== removeIndex).map((item, index) => {
      item.path = `[${index}]`;
      item.updateTime = new Date().getTime();
      updateChildrenPathRecursive(item);

      return item;
    })

    payload = {convertData, path: null}
    commit('setCurrentSelection', null);
  } else {
    const componentRegex = new RegExp('component$', 'g');
    if(componentRegex.test(path)) {
      // set current selection is component (current path - ".component".length)
      await commit('setCurrentSelection', path.substring(0, path.length - 10));

      return commit('updateSettings', {key: 'component', value: null})
    }

    const parentPath = path.replace(/[\d\[\]]+$/, '');
    const removeIndex = parseInt(path.match(/[0-9]]+$/g)[0].replace(']', ''));

    const convertData = cloneDeep(get(state.convertData, parentPath)).filter((item, index) => index !== removeIndex).map((item, index) => {
      item.path = `${parentPath}[${index}]`;
      item.updateTime = new Date().getTime();
      updateChildrenPathRecursive(item);

      return item;
    })

    payload = {convertData, path: parentPath}

    // check if delete proposal
    const proposal = payload.path.substring(payload.path.length - 9);
    if(proposal !== 'proposals') {
      commit('setCurrentSelection', payload.path.substring(0, payload.path.length - 9));
    }
  }

  commit('setConvertData', payload);

  // commit('removeComponent', path)
  // state.convertData.forEach(item => {
  //
  // })
}

export async function downloadSample({state}, fileId) {
  // this.$adminRepositories.applications
  const { errResponse, data: responseData } = await this.$adminRepositories.applications.testDownload({
    fileId,
    payload: state.convertData,
  })

  return errResponse ? null : responseData.data;
}

export const updateSettings = ({commit, state}, payload) => {
  if(payload.path) {
    return commit('updateSettingsWithPath', payload)
  }

  const currentSelection = get(state.convertData, state.currentSelection);

  switch (currentSelection.type) {
    case 'paragraph':
    case 'list':
    case 'newList':
    case 'table':
    case 'image':
    case 'listItem':
      return commit('updateSettings', payload)
  }
}

export const addParagraph = ({commit, state}, isNew = false) => {
  let path, parent, options = null;
  if (state.currentSelection) {
    const newSectionIndex = get(state.convertData, `${state.currentSelection}.children`).length;
    path = `${state.currentSelection}.children[${newSectionIndex}]`;
    parent = `${state.currentSelection}.children`;
  } else {
    options = {
      isLoop: false,
      questionId: null,
      settings: false,
      ruleId: null,
      inheritRuleId: null,
      hasCondition: false,
      conditions: null,
      condition_options: [],
      required_all: false
    };
    path = `[${state.convertData.length}]`;
    parent = null;
  }
  let styles = null;
  if (!isNew) {
    styles = {
      bold: false,
      italic: false,
      fontSize: 13,
      align: 'left',
      indent: 0,
      color: '#000000',
      lineHeight: 1.15,
      spaceBefore: 0,
      spaceAfter: 200,
    };
  }
  commit('addElement', {
    payload: {
      path,
      type: isNew ? 'newParagraph' : 'paragraph',
      content: [],
      html: '',
      json: {type: 'doc', content: []},
      styles,
      options,
      url: '',
      proposals: []
    },
    parent
  })
}

export const addList = ({commit, state}, isNew = false) => {
  let path, parent, options = null;
  if (state.currentSelection) {
    const newSectionIndex = get(state.convertData, `${state.currentSelection}.children`).length;
    path = `${state.currentSelection}.children[${newSectionIndex}]`;
    parent = `${state.currentSelection}.children`;
  } else {
    path = `[${state.convertData.length}]`;
    parent = null;
  }

  options = {
    isLoop: false,
    questionId: null,
    settings: false,
    ruleId: null,
    inheritRuleId: null,
    hasCondition: false,
    conditions: null,
    condition_options: [],
    required_all: false
  };

  commit('addElement', {
    payload: {
      path,
      type: isNew ? 'newList' : 'list',
      children: [],
      pattern: {
        template: 'Number:number:',
        tab: 200,
        indent: 0,
        type: 'custom',
        fontSize: 10.5,
      },
      styles: {
        bold: false,
        italic: false,
        fontSize: 13,
        align: 'left',
        color: '#000000',
        lineHeight: 1.15,
        spaceBefore: 0,
        spaceAfter: 200,
      },
      options
    },
    parent
  })
}

export const addListItem = ({commit, state}, { payload, styles }) => {
  const newSectionIndex = get(state.convertData, `${state.currentSelection}.children`).length;
  const uniqId = uuid();

  const path = `${state.currentSelection}.children[${newSectionIndex}]`;

  commit('addElement', {
    payload: {
      path,
      id: uniqId,
      type: 'section',
      isListItem: true,
      children: [
        {
          path: `${path}.children[0]`,
          type: 'paragraph',
          content: [
            {
              type: 'normal',
              content: payload,
              styles,
              url: '',
              path: `${path}.children[0].content[0]`
            }
          ],
          styles,
          proposals: []
        }
      ],
      styles,
      textOnly: true,
      content: payload,
      updateTime: new Date().getTime(),
      options: {
        isLoop: false,
        questionId: null,
        hasCondition: false,
        conditions: null,
        condition_options: [],
        required_all: false
      }
    },
    parent: `${state.currentSelection}.children`
  })
}

export const addListItemNew = ({commit, state}, { payload }) => {
  const newSectionIndex = get(state.convertData, `${state.currentSelection}.children`).length;
  const uniqId = uuid();

  const path = `${state.currentSelection}.children[${newSectionIndex}]`;
  commit('addElement', {
    payload: {
      path,
      id: uniqId,
      type: 'newListItem',
      isListItem: true,
      children: [
        {
          path: `${path}.children[0]`,
          type: 'newParagraph',
          content: [],
          html: '',
          json: {type: 'doc', content: []},
          proposals: [],
        }
      ],
      textOnly: true,
      content: payload,
      updateTime: new Date().getTime(),
      options: {
        isLoop: false,
        questionId: null,
        settings: false,
        ruleId: null,
        inheritRuleId: null,
        hasCondition: false,
        conditions: null,
        condition_options: [],
        required_all: false
      }
    },
    parent: `${state.currentSelection}.children`
  })
}

export const addTable = ({commit, state}) => {
  let path, parent, options = null;
  if (state.currentSelection) {
    const newSectionIndex = get(state.convertData, `${state.currentSelection}.children`).length;
    path = `${state.currentSelection}.children[${newSectionIndex}]`;
    parent = `${state.currentSelection}.children`;
  } else {
    path = `[${state.convertData.length}]`;
    parent = null;
    options = {
      isLoop: false,
      questionId: null,
      settings: false,
      ruleId: null,
      inheritRuleId: null,
      hasCondition: false,
      conditions: null,
      condition_options: [],
      required_all: false
    };
  }

  commit('addElement', {
    payload: {
      path,
      type: 'table',
      children: [],
      options
    },
    parent
  })
}

export const addPageBreak = ({commit, state}) => {
  const newSectionIndex = get(state.convertData, `${state.currentSelection}.children`).length;

  commit('addElement', {
    payload: {
      path: `${state.currentSelection}.children[${newSectionIndex}]`,
      type: 'pagebreak',
    },
    parent: `${state.currentSelection}.children`
  })
}

export async function removeUnusedWords({commit, state, dispatch = null},
                                        { removeIndex, path }) {
  path = path || state.currentSelection;
  const component = get(state.convertData, path)
  const word = component.content[removeIndex];
  if(word.type === "fieldInstance") {
    const {errResponse} = await dispatch('admin/applications/deleteFieldInstance', {id: word.uuid, fieldId: word.fieldId}, {root: true});

    if(errResponse) {
      return false;
    }
  }

  const words = cloneDeep(
    component.content.filter((word, index) => index !== removeIndex)
  ).map((word, index) => {
    word.path = `${path}.content[${index}]`;

    return word;
  })

  await commit('updateSettingsWithPath', {
    key: 'content',
    value: words,
    path
  })

  return true;
}

export const addProposal = ({commit, state}) => {
  const newIndex = get(state.convertData, `${state.currentSelection}.proposals`).length;
  const path = `${state.currentSelection}.proposals[${newIndex}]`;

  commit('addElement', {
    parent: `${state.currentSelection}.proposals`,
    payload: {
      path,
      content: [],
      styles: {
        bold: false,
        italic: false,
        fontSize: 13,
      },
      url: '',
      type: 'proposal'
    }
  })
}

export const addWord = ({commit, state}, payload) => {
  const path = `${payload.path}.content`;

  const newSectionIndex = get(state.convertData, path).length;
  payload.path = `${path}[${newSectionIndex}]`;

  commit('addElement', {
    payload,
    parent: path
  })
}

export const addImage = ({commit, state}) => {
  const newSectionIndex = get(state.convertData, `${state.currentSelection}.children`).length;

  commit('addElement', {
    payload: {
      path: `${state.currentSelection}.children[${newSectionIndex}]`,
      type: 'image',
      src: null,
      styles: {
        align: 'left',
        size: null
      }
    },
    parent: `${state.currentSelection}.children`
  })
}

export const setCurrentSelection = ({commit, state}, path) => {
  commit('setCurrentSelection', path);
  commit('setParentStyles', null);
}

export const setParentStyles = ({commit, state}, parentStyle) => {
  commit('setParentStyles', parentStyle);
}

export const sortBlock = ({commit, state}, {newIndex, oldIndex, parent}) => {
  const oldItem = cloneDeep(get(state.convertData, `${parent}[${oldIndex}]`));
  const newItem = cloneDeep(get(state.convertData, `${parent}[${newIndex}]`));

  const temp = oldItem.path;
  oldItem.path = newItem.path;
  oldItem.updateTime = new Date().getTime();
  newItem.path = temp;
  newItem.updateTime = new Date().getTime();

  updateChildrenPathRecursive(newItem)
  updateChildrenPathRecursive(oldItem)

  commit('sortBlock', {oldItem, newItem, parent, oldIndex, newIndex});
}

export const setRootState = ({commit, state}, payload) => {
  const {
    convertData = [],
    currentSelection = null,
    removeInstanceFields = [],
    type = 'pure_word',
    options = {}
  } = payload;

  commit('setConvertData', { convertData })
  commit('setCurrentSelection', currentSelection)
  commit('setRemoveInstanceFields', removeInstanceFields)
  commit('setType', type)
  commit('setOptions', options)
}

export async function createApplication({commit, state}, payload) {
  return await this.$adminRepositories.applications.createWord(payload);
}

export async function createNewAppFile({commit}, payload) {
  const result = await this.$adminRepositories.applications.createNewAppFile(payload);
  const { errResponse, data: responseData } = result;

  if(!errResponse) {
    await commit('admin/applications/addFile', responseData.data, {root: true});
  }

  return result;
}

export async function createNewAppPdfFile({commit}, payload) {
  const result = await this.$adminRepositories.applications.createNewAppPdfFile(payload);
  const { errResponse, data: responseData } = result;

  if(!errResponse) {
    await commit('admin/applications/addFile', responseData.data, {root: true});
  }

  return result;
}

export async function cloneAppFile({commit}, payload) {
  const result = await this.$adminRepositories.applications.cloneAppFile(payload);
  const { errResponse, data: responseData } = result;

  if(!errResponse && responseData.data) {
    await commit('admin/applications/addFile', responseData.data, {root: true});
  }

  return result;
}

export async function updateWordConfigFile({state, commit, dispatch}, { id, fileId, index }) {
  const tmpRemovePlaceholder = state.removeInstanceFields;

  const response = await this.$adminRepositories.applications.updateWordConfigFile({id, config: state, fileId});
  const {errResponse, data: responseData} = response;

  if(!errResponse) {
    // all update config
    await commit('admin/applications/updateWordFileConfig', {
      index,
      config: cloneDeep(state)
    }, {root: true});

    // TODO: need refactor -> lit
    await commit('admin/applications/setApplication', responseData.data, {root: true});

    Notify.success({title: responseData.message}, true)
  }

  // reset remove placeholder
  commit('setRemovePlaceholders', []);

  // update field instance
  await dispatch('admin/applications/removeFieldInstancesFromIdListHandle', tmpRemovePlaceholder, {root: true});

  return response
}

export async function uploadWordTemplate({commit}, payload) {
  const { errResponse, data: responseData } = await this.$adminRepositories.applications.uploadWordTemplate(payload);

  if(!errResponse) {
    // call update file path
    await commit('admin/applications/setFilePath', {
      fileId: parseInt(payload.get('file_id')),
      path: responseData.data
    }, {root: true});

    return responseData.message;
  }

  await Notify.error({title: responseData.data.hasOwnProperty('template') ? responseData.data.template[0] : responseData.message}, true)
  return false;
}

export async function updateConfigConditionFile({commit}, {fileId, options, name}) {
  const { errResponse, data } = await this.$axios.put(`/admin/v1/applications/update-config/${fileId}`, {options, name});

  if(!errResponse) {
    await commit('setOptions', options)
    await commit('admin/applications/updateFileName', {fileId, name}, {root: true});
    await commit('admin/applications/updateFileCondition', {fileId, options}, {root: true});

    return data.message;
  }

  return false;
}

export const setGlobalStyles = ({commit, state}, payload) => {
  commit('setGlobalStyles', payload);
}

const updateChildrenPathRecursive = (item) => {
  if(item.hasOwnProperty('children') && item.children.length) {
    if(item.type === 'table') {
      item.children.forEach(row => {
        row.items.forEach(cell => {
          if(cell.component) {
            cell.component.path = item.path + cell.component.path.substring(item.path.length);
            updateChildrenPathRecursive(cell.component)
          }
        })
      })
    } else {
      item.children.forEach(child => {
        child.path = item.path + child.path.substring(item.path.length);
        updateChildrenPathRecursive(child)
      })
    }
  }

  // update word path
  // if(item.type === 'paragraph') {
  //   item.content.forEach(word => {
  //     word.path = item.path + word.path.substring(item.path.length)
  //   })
  // }
}

export async function uploadTempPdfFile({commit, state}, payload) {
  return await this.$adminRepositories.applications.uploadTempPdfFile(payload);
}

export async function createByApplication({commit}, payload) {
  const result = await this.$adminRepositories.applications.createByApplication(payload);
  const { errResponse, data: responseData } = result;

  return result;
}